import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=5779b71d&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=js&"
export * from "./Rule.vue?vue&type=script&lang=js&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=5779b71d&scoped=true&lang=css&"
import style1 from "./Rule.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779b71d",
  null
  
)

export default component.exports